export default "__VITE_ASSET__B9r92dSl__"